export default __webpack_public_path__ + "static/media/game-icon.96d11af9.svg";